import { atom } from "recoil";


const hoveredElementIdAtom = atom<null | number>({
    default: null,
    key: 'hoveredElement'
})

export {hoveredElementIdAtom}